import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CategoryService, DonationRequestDto, FamilyService } from 'src/app/backend';
import { BasePagedComponent } from 'src/app/core/components/base-paged/base-paged.component';
import { DonationService } from '../../../backend/api/donation.service';
import { MemberRequestDto } from '../../../backend/model/memberRequestDto';
import { SexEnum } from '../../../backend/model/sexEnum';
import { BaseComponent } from '../../../core/components/base/base.component';
import { DialogRef } from '../../../core/dialog/dialog-ref';
import { DialogConfig } from '../../../core/dialog/dialog.service';
import { AuthService } from '../../../core/services/auth.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

interface UserRow {
  id: number;
  representative: string;
  phone: string;
  address: string;
  city: string;
}

interface CategoryRow {
  id: number;
  name: string;
}

@Component({
  templateUrl: './save-donation-dialog.component.html',
  //   styleUrls: ['./save-user-dialog.component.scss'],
})

export class SaveDonationDialogComponent extends BasePagedComponent implements OnInit {
  dataFamilies: UserRow[] = [];
  dataCategories: CategoryRow[] = [];
  searchQueryControl = new UntypedFormControl('');
  SexEnum = SexEnum;
  form = new UntypedFormGroup({});
  id = 0;
  familyId = 0;
  categoryId = 0;
  isLoading = false;
  isSaving = false;

  constructor(
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef,
    private t: TranslateService,
    private donationsService: DonationService,
    private familiesService: FamilyService,
    private categoriesService: CategoryService,
    authService: AuthService,
    messageService: NzMessageService
  ) {
    super(authService, t, messageService);
    const config = this.dialogConfig;
    this.id = config.data?.id;
    this.familyId = config.data?.familyId;
    this.categoryId = 0;

    this.form = new UntypedFormGroup({
      name: new UntypedFormControl(''),
      note: new UntypedFormControl(''),
      familyId: new UntypedFormControl(this.familyId),
      categoryId: new UntypedFormControl(0),
      donationDate: new UntypedFormControl(0),
      id: new UntypedFormControl(0),
    });

    if (this.id) {
      this.loadDonation(this.id);
    }
    this.loadFamilies();
    this.loadCategories();
  }

  ngOnInit() {
  }

  loadDonation(id: number) {
    this.isLoading = true;

    this.donationsService.apiDonationIdGet({ id }).subscribe(
      (res) => {
        console.log(res);
        this.isLoading = false;
        this.form.patchValue({
          name: res.name,
          note: res.note,
          familyId: res.familyId,
          categoryId: res.categoryId,
          donationDate: res.donationDate,
          id: res.id
        });
      },
      () => {
        this.isLoading = false;
        this.close();
      }
    );
  }

  close(saved?: boolean) {
    this.dialogRef.close({ saved });
  }

  save() {
    if (!this.form.valid) {
      for (const i in this.form.controls) {
        this.form.controls[i].markAsDirty();
        this.form.controls[i].updateValueAndValidity();
      }
      return;
    }

    const data: DonationRequestDto = {
      familyId: this.form.value.familyId || this.familyId,
      name: this.form.value.name,
      categoryId: this.form.value.categoryId || this.categoryId,
      note: this.form.value.note,
      donationDate: this.form.value.donationDate,
      id: this.form.value.id
    };

    const apiCall = this.id
      ? this.donationsService.apiDonationPut({
        donationRequestDto: data,
        })
      : this.donationsService.apiDonationPost({ donationRequestDto: data });

    this.isSaving = true;

    apiCall.subscribe(
      (res: any) => {
        this.isSaving = false;
        this.close(true);
      },
      (err: any) => {
        this.isSaving = false;
        this.errorHandler(err, this.form);
      }
    );
  }

  disabledEndDate = (endValue: Date): boolean => {
    if (endValue.getDate() < new Date().getDate()) {
      return false;
    }

    return true;
  }

  loadFamilies() {
    this.isLoading = true;

    this.familiesService
      .apiFamilyGet({
        query: this.searchQueryControl.value,
        isFullSize: true,
        orderByKey: 'Representative'
      })
      .subscribe(
        (res) => {
          console.log('Porodice');
          console.log(res);

          this.isLoading = false;
          this.dataFamilies =
            res.results?.map((x) => ({
              id: x.id || 0,
              representative: x.representative || '',
              phone: x.phone || '',
              address: x.address || '',
              city: x.city || '',
            })) || [];
        },
        (err) => {
          this.isLoading = false;
        }
      );
  }

  loadCategories() {
    this.isLoading = true;
    this.categoriesService
    .apiCategoryGet({
      ...this.tableData,
      filter: JSON.stringify({
      }),
    })
    .subscribe(
      (res) => {
        this.pageLoaded(res);
        this.isLoading = false;
        this.dataCategories =
          res.results?.map((x) => ({
            id: x.id || 0,
            name: x.name || '',
          })) || [];
      },
      (err) => {
        this.isLoading = false;
      }
    );
    }
}
